import { ratingLevels, watchTips } from "@/mocks/films";
import SectionHeading from "./SectionHeading";

const levelStyles: Record<string, { badge: string; bar: string }> = {
  secondary: {
    badge: "bg-secondary-100 text-secondary-900",
    bar: "bg-secondary-500",
  },
  primary: {
    badge: "bg-primary-100 text-primary-800",
    bar: "bg-primary-500",
  },
  accent: {
    badge: "bg-accent-100 text-accent-800",
    bar: "bg-accent-500",
  },
};

export default function WatchGuide() {
  return (
    <section id="guide" className="border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="观影指南"
          title="看得明白，也看得安心"
          desc="伦理题材往往情绪浓度较高，选片之前先了解分级与内容倾向，能让你更从容地享受一部作品。"
        />

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-[1.1fr_1fr] lg:items-stretch">
          <div className="relative h-56 overflow-hidden rounded-lg border border-background-200 md:h-full md:min-h-[280px]">
            <img
              src="https://readdy.ai/api/search-image?query=Wide%20cinematic%20film%20still%20of%20an%20empty%20vintage%20cinema%20auditorium%20with%20warm%20golden%20screen%20glow%2C%20rows%20of%20deep%20red%20seats%20and%20rich%20shadows%2C%20nostalgic%20atmospheric%20mood%2C%20warm%20amber%20and%20brown%20color%20grading%2C%20soft%20film%20grain%2C%20editorial%20photography&width=1600&height=600&seq=guide-cinema-hall&orientation=landscape"
              alt="暖色调的老式影院放映厅，营造沉浸的观影氛围"
              className="h-full w-full object-cover object-top"
            />
          </div>

          <div className="flex flex-col gap-3">
            {ratingLevels.map((item) => {
              const style = levelStyles[item.color] ?? levelStyles.primary;
              return (
                <div
                  key={item.level}
                  className="flex gap-3 rounded-lg border border-background-200 bg-background-50 p-4"
                >
                  <span className={`w-1 shrink-0 rounded-full ${style.bar}`}></span>
                  <div>
                    <div className="flex flex-wrap items-center gap-2">
                      <span
                        className={`rounded-full px-2.5 py-1 text-xs font-label font-medium ${style.badge}`}
                      >
                        {item.level}
                      </span>
                      <span className="text-xs font-label text-foreground-500">
                        韩国分级参考
                      </span>
                    </div>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                      {item.desc}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {watchTips.map((tip) => (
            <div
              key={tip.title}
              className="rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className={`${tip.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                {tip.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                {tip.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}